export async function yieldToMainThread(): Promise<void> {
    if ( window.scheduler && typeof window.scheduler.yield === 'function' ) {
        return await window.scheduler.yield();
    }

    return new Promise( ( resolve ) => {
        window.setTimeout( resolve, 0 );
    } );
}
